import { render, staticRenderFns } from "./job-form-specs-delivery-info.vue?vue&type=template&id=22619cea&scoped=true"
import script from "./job-form-specs-delivery-info.vue?vue&type=script&lang=js"
export * from "./job-form-specs-delivery-info.vue?vue&type=script&lang=js"
import style0 from "./job-form-specs-delivery-info.vue?vue&type=style&index=0&id=22619cea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22619cea",
  null
  
)

export default component.exports